import React, { Component } from 'react';
import {
    BodyLargeRegular,
    Button,
    CrossIcon,
    DisplayExtraSmall,
    Input,
    Item,
    Label,
    Modal,
    ModalHeader,
    Multiselect
} from 'prospect-path-base';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import publishProduct from '../../../actions/product-management/PublishProduct';


class ConfirmProduct extends Component {
    constructor(props) {
        super(props);

        this.state = {
            product: {
                name: null,
                categories: null,
            },
            noCategoriesError: false,
        };

        this.updateProduct = this.updateProduct.bind(this);
        this.handleChangeName = this.handleChangeName.bind(this);
        this.handleChangeCategories = this.handleChangeCategories.bind(this);
    }
    updateProduct() {
        // Only update if values have changed
        if (this.state.product.name != null || this.state.product.categories != null) {
            const data = Object.assign({}, this.props.product, {
                data_value_ids: this.props.product.data_values,
                primary_category_id: this.props.product.primary_software_category_id,
                additional_category_ids: this.props.product.additional_software_categories,
            });

            if (this.state.product.name != null) {
                data.name = this.state.product.name;
            }
            if (this.state.product.categories != null) {
                const categories = [...this.state.product.categories];
                data.primary_category_id = categories.shift();
                data.additional_category_ids = categories;

                // For now wipe data values if categories have changed
                data.data_value_ids = [];
            }

            // If there are no categories show an error and don't update the product
            if (data.primary_category_id == null) {
                this.setState({
                    noCategoriesError: true,
                });
                return;
            } else {
                this.setState({
                    noCategoriesError: false,
                });
            }

            this.props.publishProduct(this.props.currentTeamId, this.props.product.id, data)
              .then(success => {
                  if (success) {
                      this.props.closeModal();
                  } else {
                      // Error handling
                  }
              });
        } else {
            this.props.closeModal();
        }
    }
    handleChangeName(event) {
        this.setState({
            product: {
                ...this.state.product,
                name: event.target.value,
            }
        });
    }
    handleChangeCategories(categories) {
        this.setState({
            product: {
                ...this.state.product,
                categories,
            }
        });
    }
    render() {
        if (!this.props.isOpen) {
            return '';
        }

        return (
            <Modal
                isOpen={this.props.isOpen}
            >
                <ModalHeader
                    title={(
                        <div>
                            <DisplayExtraSmall>Confirm Product</DisplayExtraSmall>
                            <BodyLargeRegular>
                                Please check the details of your product are correct
                            </BodyLargeRegular>
                        </div>
                    )}
                    close={<CrossIcon onClick={this.props.closeModal} />}
                />

                <Item>
                    <Label htmlFor="name">Product name</Label>
                    <Input
                      id="name"
                      value={
                            this.state.product.name == null ?
                              this.props.product.name :
                              this.state.product.name
                        }
                      onChange={this.handleChangeName}
                    />
                </Item>

                <Item
                  error={this.state.noCategoriesError ? 'The product must have at least one category' : ''}
                >
                    <Label htmlFor="category">Categories</Label>
                    <Multiselect
                        options={[
                            {
                                label: "Categories",
                                options: this.props.categories.map(category => ({
                                    label: category.name,
                                    value: category.id,
                                })),
                            },
                        ]}
                        onChange={this.handleChangeCategories}
                        initialValues={
                            [
                              this.props.product.primary_software_category_id,
                              ...this.props.product.additional_software_categories,
                            ].filter(value => value !== null)
                        }
                    />
                </Item>

                {/*<Item hint="Where can you support customers of this product?">*/}
                {/*    <Label htmlFor="regions">Location(s)</Label>*/}
                {/*    <Multiselect*/}
                {/*        options={[*/}
                {/*            {*/}
                {/*                label: "Group 1",*/}
                {/*                options: [*/}
                {/*                    { label: "Group 1, option 1", value: "value_1" },*/}
                {/*                    { label: "Group 1, option 2", value: "value_2" }*/}
                {/*                ]*/}
                {/*            },*/}
                {/*            {*/}
                {/*                label: "Group 2",*/}
                {/*                options: [*/}
                {/*                    { label: "Group 2, option 1", value: "value_3" },*/}
                {/*                    { label: "Group 2, option 2", value: "value_4" }*/}
                {/*                ]*/}
                {/*            }*/}
                {/*        ]}*/}
                {/*    />*/}
                {/*</Item>*/}

                <div style={{ display: 'flex' }}>
                    <Button
                        style={{ width: '25%', marginRight: '0.75rem' }}
                        block
                        color="secondary"
                        onClick={this.props.closeModal}
                    >
                        Back
                    </Button>
                    <Button
                        block
                        onClick={this.updateProduct}
                    >
                        Confirm product
                    </Button>
                </div>
            </Modal>
        );
    }
}

const mapStateToProps = state => ({
    currentTeamId: state.teams.currentTeam,
    categories: state.productManagement.categories.all,
});

const mapDispatchToProps = dispatch => ({
    publishProduct: (teamId, productId, data) => dispatch(publishProduct(teamId, productId, data)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ConfirmProduct));
